import { handleActions } from 'redux-actions';
import { guid, addToCache } from '../utils';

const INITIAL_STATE = {
  loaded: false,
  posts: [],
  ads: {
    left_sidebar_ad_image: null,
    left_sidebar_ad_link: null,

    right_sidebar_ad_image: null,
    right_sidebar_ad_link: null,

    page_body_wide_ad: null,
    page_body_wide_ad_link: null,

    article_sidebar_ad_image: null,
    article_sidebar_ad_link: null,
  },
  carousel: [],
  home: {
    page: 1,
    max_num_pages: 1,
    posts: []
  },
  music: {
    page: 1,
    max_num_pages: 1,
    posts: []
  },
  featured: {
    page: 1,
    max_num_pages: 1,
    posts: []
  },
  interviews: {
    page: 1,
    max_num_pages: 1,
    posts: []
  },
};

/**
 * player in state
 */
export const content = handleActions(
  {
    SET_LOADED: (state, action) => {
      return Object.assign({}, state, {
        loaded: action.payload
      });
    },
    ADD_CONTENT: (state, action) => {
      return Object.assign({}, state, {
        posts: addToCache(state.posts, action.payload)
      });
    },
    ADD_PAGE_CONTENT: (state, action) => {
      return Object.assign({}, state, {
        [action.page]: Object.assign({}, state[action.page], {
          posts: addToCache(state[action.page].posts, action.payload),
          page: action.page_number ? action.page_number : state[action.page].page,
          max_num_pages: action.max_num_pages ? action.max_num_pages : state[action.page].max_num_pages,
        })
      });
    },
    UPDATE_HOMEPAGE_CAROUSEL: (state, action) => {
      return Object.assign({}, state, {
        carousel: action.payload
      });
    },
    UPDATE_ADS: (state, action) => {
      return Object.assign({}, state, {
        ads: action.payload
      });
    },
    ADD_POST: (state, action) => {
      return addToCache(state, null, action.payload);
    },
    REPLACE_CONTENT: (state, action) => {
      return Object.assign({}, state, {
        posts: action.payload
      });
    }
  },
  INITIAL_STATE
);



// WEBPACK FOOTER //
// ./src/reducers/content.js